import { memo, useCallback } from "react";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";
import { Button } from "ui/components/Button/Button";
import FileUploadList from "ui/components/FileUpload/FileUploadList/FileUploadList";

interface DamagePhotoListProps {
  photos: FleetDocumentUpload[];
  selectedPhotoId: string | null;
  onPhotoSelect: (id: string) => void;
  onPhotoDelete: (id: string) => void;
  onUploadClick: () => void;
}

/**
 * Popis fotografija štete uz preglednik — odabir slike i jedini ulaz za dodavanje.
 */
const DamagePhotoList: React.FC<DamagePhotoListProps> = (props) => {
  const { photos, selectedPhotoId, onPhotoSelect, onPhotoDelete, onUploadClick } =
    props;

  // FileUploadList vraća cijelu datoteku, a preglednik traži samo njezin id.
  const handlePhotoItemClick = useCallback(
    (file: FleetDocumentUpload) => {
      onPhotoSelect(file.id);
    },
    [onPhotoSelect]
  );

  return (
    // Gornja polovica desnog stupca — širinu i visinu određuje roditelj.
    <div className="flex-1 min-h-0 flex flex-col border border-slate-200 bg-slate-50 overflow-hidden">
      <div className="p-3 flex flex-col min-h-0">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
            Fotografije
          </h3>
          <Button
            variant="primary"
            size="small"
            startIcon="/media/icons/plus.svg"
            onClick={onUploadClick}
          >
            Dodaj fotografiju
          </Button>
        </div>

        {photos.length === 0 ? (
          <p className="text-sm text-slate-500 pb-2">
            Dodajte fotografiju kako biste označili štete.
          </p>
        ) : (
          <div className="flex-1 min-h-0 overflow-y-auto">
            <FileUploadList
              files={photos}
              activeId={selectedPhotoId ?? undefined}
              onItemClick={handlePhotoItemClick}
              onDelete={onPhotoDelete}
              deleteTitle="Brisanje fotografije"
              deleteMessage="Fotografija i sve označene štete na njoj bit će obrisane. Želite li nastaviti?"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(DamagePhotoList);
